import Vue from 'vue';

const map = new WeakMap();

function toShadowDom(el, htmlText, styleText = '') {
  let shadowRoot;
  if (map.get(el)) {
    shadowRoot = map.get(el);
  } else {
    shadowRoot = el.attachShadow({ mode: 'closed' });
    map.set(el, shadowRoot);
  }

  // 清空 Shadow DOM 内容
  shadowRoot.innerHTML = '';

  // 添加 HTML 内容
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlText;

  // 移动内容到 Shadow DOM 中
  while (tempDiv.firstChild) {
    shadowRoot.appendChild(tempDiv.firstChild);
  }

  // 添加样式
  if (styleText) {
    const style = document.createElement('style');
    style.textContent = styleText;
    shadowRoot.appendChild(style);
  }

  // 执行脚本
  const scripts = shadowRoot.querySelectorAll('script');
  scripts.forEach(script => {
    const newScript = document.createElement('script');
    newScript.textContent = script.textContent;
    [...script.attributes].forEach(attr => newScript.setAttribute(attr.name, attr.value));
    shadowRoot.appendChild(newScript);
    // 移除旧的script标签
    script.remove();
  });

  // 附加脚本到 Shadow DOM
  executeShadowScripts(shadowRoot, el);
}

function executeShadowScripts(shadowRoot, el) {
  // 在 Shadow DOM 执行脚本
  const dropdown = shadowRoot.querySelectorAll('.dropdown-btn');
  for (let i = 0; i < dropdown.length; i++) {
    console.log(dropdown[i]);
    dropdown[i].addEventListener('click', function () {
      this.classList.toggle('active');
      const dropdownContent = this.nextElementSibling;
      if (dropdownContent.style.display === 'block') {
        dropdownContent.style.display = 'none';
      } else {
        dropdownContent.style.display = 'block';
      }
    });
  }

  // 处理锚点跳转
  const anchorLinks = shadowRoot.querySelectorAll('a[href^="#"]');
  anchorLinks.forEach(anchor => {
    anchor.addEventListener('click', (event) => {
      event.preventDefault();
      const targetId = anchor.getAttribute('href').substring(1);
      // 修改URL的hash部分并跳转
      window.location.hash = targetId;
      // 处理特殊字符的情况，比如 '.' 需要转义
      const escapedId = CSS.escape(targetId);
      // 查找目标元素并滚动到视图中
      const targetElement = shadowRoot.getElementById(escapedId) || el.querySelector(`#${escapedId}`);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
}

function handleBindingVal(binding) {
  let htmlText, styleText;
  if (typeof binding.value === 'object') {
    htmlText = binding.value.htmlText;
    styleText = binding.value.styleText;
  } else {
    htmlText = binding.value;
  }
  return { htmlText, styleText };
}

Vue.directive('richText', {
  bind(el, binding) {
    const { htmlText, styleText } = handleBindingVal(binding);
    toShadowDom(el, htmlText, styleText);
  },
  update(el, binding) {
    const { htmlText, styleText } = handleBindingVal(binding);
    toShadowDom(el, htmlText, styleText);
  }
});